<template>
    <div class="px-4 py-2 rounded-md">
        <div class="flex items-center">
            <div class="flex-shrink-0">
                <slot name="icon"></slot>
            </div>
            <div class="flex-1 ml-3 md:flex md:justify-between">
                <p class="text-sm">
                    <slot name="text"></slot>
                </p>
                <p v-if="hasLink" class="mt-3 text-sm md:ml-6 md:mt-0">
                    <span class="hover:text-blue-600 text-blue-700 whitespace-nowrap font-medium">
                        <slot name="link"></slot>
                        <span aria-hidden="true">&rarr;</span>
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["href"],

    computed: {
        hasLink() {
            return !!this.$slots.link
        },
    },
}
</script>
